<lib-breadcrumb [list]="breadcrumbs()"></lib-breadcrumb>

<div class="text-lg mb-5 font-semibold text-gray-800">
  List Of Files
</div>

<div class="p-2 md:p-4 space-y-6" [class.blur-sm]="loading" [class.pointer-events-none]="loading">
  
  <form class="bg-fieldset p-4 md:p-6 mb-4 rounded-lg shadow-sm border border-gray-200 bg-white"
        [formGroup]="searchFormGrp" 
        (ngSubmit)="searchHandler()">
        
   <div class="grid grid-cols-1 md:grid-cols-12 gap-4">
    
    <div class="col-span-1 md:col-span-5">
        <app-case-number-search [label]="userType==='lawyer'?'Case Number':'Appeal Number'"
          (caseSelected)="onCaseSearchOptionSelected($event)" formControlName="caseNumber">
        </app-case-number-search>
    </div>
    <div class="col-span-1 md:col-span-3 flex items-start">
        
        <div class="flex gap-3 w-full mt-1 md:mt-5 justify-start">
          
          <button type="reset" 
                  class="btn-custom btn-outline w-full md:w-auto" 
                  (click)="resetHandler()">
            Reset
          </button>
          
          <button type="submit" 
                  class="btn-custom btn-primary w-full md:w-auto">
            Search
          </button>
          
        </div>
      </div>


  </div>
  </form>

  <ng-container *ngIf="fileDataSource && fileDataSource.data.length">
    <div class="bg-white rounded-lg shadow-sm border border-gray-200 overflow-hidden">
      
      <div class="flex justify-between items-center p-4 border-b border-gray-100 bg-gray-50">
        <h3 class="text-lg font-medium text-gray-800 m-0">Search Results</h3>
        <button mat-button class="print-button" (click)="onPrint()">
          <mat-icon fontIcon="print" class="mr-2 text-gray-600"></mat-icon>
          <span class="text-gray-700 font-medium">Print List</span>
        </button>
      </div>

      <div class="result-table-container">
        <table mat-table [dataSource]="fileDataSource" matSort class="w-full">
          <ng-container *ngFor="let col of columnDefinitions" [matColumnDef]="col.column">
            <th mat-header-cell *matHeaderCellDef mat-sort-header [ngStyle]="getColumnStyle(col.column)" 
                class="header-cell whitespace-nowrap px-4 py-3 bg-gray-50 text-gray-600 font-bold text-xs uppercase tracking-wider">
              {{ col.labels[userType] }}
            </th>
            <td mat-cell *matCellDef="let element" [ngStyle]="getColumnStyle(col.column)" class="px-4 py-3 border-b border-gray-100">
              <ng-container [ngSwitch]="col.column">
                <span *ngSwitchCase="'documentId'" class="cell-content text-black-500 font-mono text-xs">{{ element.docId }}</span>
                <span *ngSwitchCase="'documentName'" class="cell-content">
                  <a href="javascript:void(0)" (click)="onDocumentClick(element)" class="doc-link font-medium hover:underline">{{ element.docName }}</a>
                </span>
                <span *ngSwitchCase="'documentTypeName'" class="cell-content text-gray-700">{{ element.docTypeName }}</span>
                <span *ngSwitchCase="'documentStatus'" class="cell-content">
                  <span class="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-green-100 text-green-800">{{ element.docStatus }}</span>
                </span>
                <span *ngSwitchCase="'dateReceived'" class="cell-content text-gray-600">{{ element.uploadedDate | date: 'dd-MMM-yyyy' }}</span>
              </ng-container>
            </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns" class="hover:bg-gray-50 transition-colors duration-150"></tr>
        </table>
      </div>
    </div>
  </ng-container>

  <ng-container *ngIf="(!fileDataSource || !fileDataSource.data.length) && !loading">
    <div class="text-center py-10 text-gray-400">
      <mat-icon class="text-4xl mb-2" fontIcon="folder_off"></mat-icon>
    </div>
  </ng-container>

</div>